module.exports = __webpack_public_path__ + "img/img-3.cc6e1fbc.jpg";